/**
 * Accessibility utilities for BaseModal
 */

import {FOCUSABLE_ELEMENTS} from './constants.js';

/**
 * Get all focusable elements within a container
 * @param {HTMLElement} parent - Parent element
 * @returns {Array} Array of focusable elements
 */
export function getFocusableNodes(parent) {
    const nodes = parent.querySelectorAll(FOCUSABLE_ELEMENTS.join(','));
    return Array.from(nodes);
}

/**
 * Set focus to the first focusable element
 * @param {Object} modal - Modal instance
 */
export function setFocusToFirstNode(modal) {
    // If disableFocus is true, don't set focus
    if (modal.config.disableFocus) return;

    const focusableNodes = getFocusableNodes(modal.modal);

    // If there are focusable elements, focus on the first one
    if (focusableNodes.length > 0) {
        focusableNodes[0].focus();
    }
}

/**
 * Maintain focus within modal (trap focus)
 * @param {Object} modal - Modal instance
 * @param {Event} event - Keyboard event
 */
export function maintainFocus(modal, event) {
    if (!event) return;

    const focusableNodes = getFocusableNodes(modal.modal);

    // If there are no focusable elements, return
    if (focusableNodes.length === 0) return;

    // Get the first and last focusable elements
    const firstFocusableNode = focusableNodes[0];
    const lastFocusableNode  = focusableNodes[focusableNodes.length - 1];

    // Check if the Tab key is pressed
    if (event.key === 'Tab') {
        // If Shift + Tab is pressed and the first element is focused
        if (event.shiftKey && document.activeElement === firstFocusableNode) {
            lastFocusableNode.focus();
            event.preventDefault();
        }
        // If Tab is pressed and the last element is focused
        else if (!event.shiftKey && document.activeElement === lastFocusableNode) {
            firstFocusableNode.focus();
            event.preventDefault();
        }
    }
}
